/**
 * Ruta de un archivo de /public (funciona aunque la app viva en un subdirectorio).
 * @param {string} u  ruta relativa, p. ej. 'images/logo.png'
 * @returns {string}
 */
export const img = (u) => `${process.env.PUBLIC_URL}/${u}`;

/**
 * Ruta de una versión web de una foto. Las genera scripts/optimizar-imagenes.js, siempre en WebP:
 * images/X/Y.jpg → images/<tamaño>/X/Y.webp
 * @param {'micro'|'mini'|'grande'} tamano
 * @param {string} u  ruta relativa de la foto original
 * @returns {string}  ruta relativa de la versión
 */
export const version = (tamano, u) => u.replace('images/', `images/${tamano}/`).replace(/\.(jpe?g|png)$/i, '.webp');

/**
 * Versión de 200 px: avatares, pines del globo, filas y miniaturas.
 * @param {string} u  ruta relativa de la foto original
 * @returns {string}
 */
export const micro = (u) => img(version('micro', u));

/**
 * Versión de 560 px: polaroids, tarjetas y certificados.
 * @param {string} u  ruta relativa de la foto original
 * @returns {string}
 */
export const mini = (u) => img(version('mini', u));

/**
 * Versión de 1600 px: hero, lightbox, fondos y foto de "Sobre mí".
 * @param {string} u  ruta relativa de la foto original
 * @returns {string}
 */
export const grande = (u) => img(version('grande', u));

/**
 * Scroll suave a una sección de Inicio, compensando el navbar fijo.
 * El globo queda justo debajo del navbar (su sección mide 100vh menos el navbar),
 * así el selector "Mis viajes / Mis viajeros" y el panel no quedan tapados.
 * @param {string} id  id de la sección ('inicio' sube al tope)
 */
export function scrollToId(id) {
  if (id === 'inicio') return window.scrollTo({ top: 0, behavior: 'smooth' });
  const el = document.getElementById(id);
  const barra = document.querySelector('.nav__bar');
  const offset = id === 'mundo' ? (barra ? barra.offsetHeight : 0) : 64;
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
}
